import { MessageDescriptor } from "react-intl";

import { ChatCreateRouteAction } from "@mapmycustomers/shared/types/chat/ChatContent";

import { blockedMessages } from "@app/component/chat/Conversation/messages/ProposalsMessage/messages";
import { MAX_ROUTE_NAME_LENGTH } from "@app/util/consts";
import { parseApiDate } from "@app/util/parsers";

import { readCreateRouteChanges, resolveCreateRouteValues } from "./createRouteDraft";

// First failing rule wins, in the order the rep reads the card. A lapsed start the agent proposed
// passes — the platform moves it forward itself — so only a start the rep set is held to "later".
const resolveCreateRouteBlockedReason = (
  action: ChatCreateRouteAction,
  draft: Record<string, unknown> | undefined
): MessageDescriptor | undefined => {
  const { endLocation, routeName, startAt, startLocation } = resolveCreateRouteValues(
    action,
    draft
  );
  const name = routeName.trim();
  if (!name) {
    return blockedMessages.addRouteName;
  }
  if (name.length > MAX_ROUTE_NAME_LENGTH) {
    return blockedMessages.routeNameTooLong;
  }
  if (!startLocation?.address.trim()) {
    return blockedMessages.addRouteStartLocation;
  }
  if (!startLocation.geoPoint) {
    return blockedMessages.pickRouteStartLocation;
  }
  const startMs = parseApiDate(startAt).getTime();
  if (Number.isNaN(startMs)) {
    return blockedMessages.addRouteStartAt;
  }
  if (readCreateRouteChanges(action, draft).startAt && startMs <= Date.now()) {
    return blockedMessages.routeStartPassed;
  }
  if (endLocation && !endLocation.geoPoint) {
    return blockedMessages.pickRouteEndLocation;
  }
  return undefined;
};

// The next moment the answer above can change on its own: the instant a start the rep set passes.
export const resolveCreateRouteBlockChangeAt = (
  action: ChatCreateRouteAction,
  draft: Record<string, unknown> | undefined
): number | undefined => {
  const { startAt } = readCreateRouteChanges(action, draft);
  const startMs = startAt ? parseApiDate(startAt).getTime() : NaN;
  return Number.isNaN(startMs) ? undefined : startMs;
};

export default resolveCreateRouteBlockedReason;
